import { devices } from "src/utils/styled/_variables.styled";
import styled from "styled-components";

export const CardCarouselContainer = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	position: relative;
	overflow: hidden;
	min-height: 50px;

	.card-slider .slick-list {
		overflow: visible;
		& .slick-track {
			display: flex !important;
			& .slick-slide {
				height: auto;
			}
		}
		& .slick-slide {
			height: 100%;
			& > div {
				height: 100%;
				padding: 16px;

				& > div {
					height: 100%;

					& > section {
						height: 100%;

						& > div {
							height: 100%;
							& > .rango-row {
								height: 100%;

								& > .card-div {
									height: 100%;
								}
							}
						}
					}
				}
			}
		}
	}

	.slick-slide {
		width: 100%;

		@media ${devices.mobile} {
			width: 350px;
		}
	}

	.slick-slider {
		width: 60%;
		left: 20%;

		@media only screen and (min-width: 632px) and (max-width: 767px) {
			width: 65% !important;
			left: 17% !important;
		}
	}

	.slick-dots {
		position: unset;
	}

	@media ${devices.mfTablet} {
		gap: 0px;
	}
`;

export const CardsWrapper = styled.div`
	width: 135%;
	overflow: hidden;

	.card-list_nav {
		display: flex;
		justify-content: center;
	}

	.card-list_nav_arrows > div {
		gap: 16px;
		display: flex;

		@media ${devices.tablet} {
			display: none;
		}

		@media ${devices.mobile} {
			display: none;
		}
	}
`;

export const CardsList = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 24px;
	list-style: none;
	padding: 0;
	margin: 0;
	padding-left: 0;
	transition: transform 0.5s ease-in-out 0s;

	@media ${devices.mfTablet} {
		flex-direction: row;
		justify-content: center;
		align-items: stretch;
	}

	@media ${devices.mfDesktop} {
		padding: 0;
		padding-left: 0;
	}
`;

export const CardListItem = styled.div`
	max-width: 100%;
	margin: 10px 0;
	min-width: 100%;

	@media ${devices.mfTablet} {
		width: 100%;
		max-width: none;
	}

	& > div {
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		max-width: none;
		min-width: unset;
		padding-top: 59px;
		padding-bottom: 59px;
		height: 100%;

		@media ${devices.mfTablet} {
			padding-top: 24px;
			padding-bottom: 24px;
		}
	}
`;

export const CardInfoContainer = styled.section`
	.topics-icons-card {
		position: relative;
		margin: auto;
	}

	.single-card {
		width: 65%;
	}

	.topics-icons-img {
		border-radius: var(--border-radius-md);
		width: 33%;
		height: 100%;
		object-fit: cover;

		&.oneColumn {
			width: 45%;
		}

		&.contain {
			object-fit: contain;
		}

		@media ${devices.tablet} {
			width: 100%;
			height: 40%;
		}

		@media ${devices.mobile} {
			width: 100%;
			height: 40%;
		}
	}

	.card-div {
		position: relative;
		display: flex;
		flex-direction: row;
		width: 200%;
		padding: 48px;
		gap: 26px;
		background-color: #ffffff;
		border-radius: var(--border-radius-md);
		z-index: 1;
		box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);

		@media ${devices.tablet} {
			height: auto;
			width: 207%;
			padding: 58px 32px;
			flex-direction: column;
		}

		@media ${devices.mobile} {
			width: 100%;
			height: auto;
			padding: var(--spacing-3x);
			flex-direction: column;
		}
	}

	.topics-card {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		column-gap: 30px;
		padding-top: inherit;
		width: 100%;

		&.oneColumn {
			grid-template-columns: 1fr;
		}

		@media ${devices.tablet} {
			width: 102%;
			display: table-column-group;
		}

		@media ${devices.mobile} {
			width: 100%;
			display: table-column-group;
		}
	}

	.icon-topic-div {
		display: flex;
		padding-bottom: 16px;
	}

	.icon-topic-div h2 {
		font-size: var(--font-size-md);

		@media only screen and (min-width: 766px) and (max-width: 817px) {
			font-size: var(--font-size-sm);
		}
	}

	.icon-topic-div p {
		padding-left: 4px;
		font-size: 16px;
		padding-top: 4px;
	}

	.icon-topic-div svg {
		width: 30px;
		height: 30px;
		margin-left: -7px;
	}

	.button-div {
		padding-top: var(--spacing-2x);
		cursor: pointer;
		margin-left: -12px;

		@media only screen and (min-width: 1023px) and (max-width: 1325px) {
			padding-top: 0px;
		}

		@media ${devices.tablet} {
			padding-top: 0px;
		}
	}

	.button-div > a > span {
		gap: 4px;

		@media ${devices.mobile} {
			width: 100%;
		}
	}

	.card-text {
		display: flex;
		flex-direction: column;
		margin: 40px 16px;
		width: 200%;

		@media ${devices.mobile} {
			width: 100%;
		}

		@media ${devices.tablet} {
			margin: 0px;
			width: 100%;
		}
	}

	div.button-div > a > span > div {
		color: inherit;
	}

	.card-text > p {
		@media ${devices.tablet} {
			width: 50% !important;
		}
		@media ${devices.mobile} {
			width: 100% !important;
		}
	}
`;
